import * as React from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

type requestFormProps = {
    showNotPossibleToDeliver: boolean,
    setShowNotPossibleToDeliver: React.Dispatch<React.SetStateAction<boolean>>

};

export const NotPossibleToDeliver = ({
                                         showNotPossibleToDeliver,
                                         setShowNotPossibleToDeliver
                                     }: requestFormProps) => {
    const [open, setOpen] = React.useState(false);
    const [openAfter, setAfterOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
        setAfterOpen(false);
        setShowNotPossibleToDeliver(false);
    };

    React.useEffect(() => {
        if (showNotPossibleToDeliver) {
            setOpen(true);
        }
    }, [showNotPossibleToDeliver]);

    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                maxWidth={'md'}
            >
                <DialogTitle sx={{m: 0, p: 2, mr: 5}} id="customized-dialog-title">
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
                <DialogContent dividers>
                    Nurodytam adresui nėra galimas pristatymas. Veiklą atliekame: Vilniuje, Kaune, Klaipėdoje
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
